module.exports = __webpack_public_path__ + "img/banner.bf8d5b15.png";